module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-ThinItalic-WebXL-24a52177f71df4ebfcdc880dc4b234e9.woff2";